(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', './../dist/css/dixa-icon-modern.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('./../dist/css/dixa-icon-modern.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.dixaIconModern);
    global.index = mod.exports;
  }
})(this, function (exports, _react) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Icon = function Icon(_ref) {
    var icon = _ref.icon,
        size = _ref.size,
        arial = _ref.arial,
        line = _ref.line,
        valign = _ref.valign,
        color = _ref.color,
        className = _ref.className;


    var style = {};
    var iconType = "";
    var realClassName = "";

    if (size) {
      style.fontSize = size + 'px';
    }

    if (line) {
      style.lineHeight = line + 'px';
    }

    if (valign) {
      style.verticalAlign = valign + 'px';
    }

    if (color) {
      style.color = color;
    }

    if (icon) {
      iconType = icon;
      if (icon.startsWith('i-') !== true) {
        iconType = 'i-' + icon;
      }
    }

    if (className) {
      realClassName = className + ' ' + iconType;
    } else {
      realClassName = iconType;
    }

    return _react2.default.createElement('span', { className: realClassName, style: style, 'aria-hidden': arial ? arial : 'false' });
  };

  exports.default = Icon;
});